import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import { addNewItem as onAddNewItem } from "store/products/actions"
import { editItem as onEditItem } from "store/products/actions"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import {showSuccessToast} from "helpers/function_helper"
import { getCategoriesAndSubCategories as onGetCategoriesAndSubCategories } from "store/products/actions"

const AddNewSubCategory = props => {
  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    subCategoryName: null,
    categoryName: null
  })
  const [categoryName, setCategoryName] = useState('')
  const [subCategoryName, setSubCategoryName] = useState('')
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [categoryList, setCategoryList] = useState([])
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  
  useEffect(() => {
    setTimeout(() => {
      document.getElementById('productcategory').focus();
      //document.getElementById('productcategory').select();
    }, 250);
    
    if(props.enteredText != ''){
      setSubCategoryName(props.enteredText)
    }
  }, [props.enteredText])

  /*

  const { response, error, addInProgress, editInProgress } = useSelector(state => ({
    response: state.Products.response,
    error: state.Products.error,
    addInProgress: state.Products.addInProgress,
    editInProgress: state.Products.editInProgress
  }))
  */

  const paddingStyles = {
    option: (styles, { data }) => {
        return {
            ...styles,
            paddingLeft : data.padding,
            paddingTop : 10,
            paddingBottom : 10,
        };
    },
  };

  useEffect(() => {
    let categoryArray = [];
    let subCategoryArray = [];
    let selectedCatOption = null;
    //console.log('props.categorySubCategoryMap:'+JSON.stringify(props.categorySubCategoryMap))
    for (const [key, value] of Object.entries(props.categorySubCategoryMap)) {
      if(!value.parentCategoryId){
        categoryArray.push({
          label : value.categoryName,
          value: value.categoryId,
          padding : 10
        })
        if(value.subCategoryList && value.subCategoryList.length > 0){
          const innerSubCat1 = value.subCategoryList
          innerSubCat1.forEach((element,i) => {
            categoryArray.push({
              options: [{
                label : element.categoryName,
                value: element.categoryId,
                padding : 30
              }]
            })
            if(element.subCategoryList && element.subCategoryList.length > 0){
              const innerSubCat2 = element.subCategoryList
              innerSubCat2.forEach(element2 => {
                categoryArray.push({
                  options: [{
                    label : element2.categoryName,
                    value: element2.categoryId,
                    padding : 50
                  }]
                })

                if(element2.subCategoryList && element2.subCategoryList.length > 0){
                  const innerSubCat3 = element2.subCategoryList
                  innerSubCat3.forEach(element3 => {
                    categoryArray.push({
                      options: [{
                        label : element3.categoryName,
                        value: element3.categoryId,
                        padding : 70
                      }]
                    })

                    if(element3.subCategoryList && element3.subCategoryList.length > 0){
                      const innerSubCat4 = element3.subCategoryList
                      innerSubCat4.forEach(element4 => {
                        categoryArray.push({
                          options: [{
                            label : element4.categoryName,
                            value: element4.categoryId,
                            padding : 90
                          }]
                        })

                        if(element4.subCategoryList && element4.subCategoryList.length > 0){
                          const innerSubCat5 = element4.subCategoryList
                          innerSubCat5.forEach(element5 => {
                            categoryArray.push({
                              options: [{
                                label : element5.categoryName,
                                value: element5.categoryId,
                                padding : 110
                              }]
                            })

                            if(element5.subCategoryList && element5.subCategoryList.length > 0){
                              const innerSubCat6 = element5.subCategoryList
                              innerSubCat6.forEach(element6 => {
                                categoryArray.push({
                                  options: [{
                                    label : element6.categoryName,
                                    value: element6.categoryId,
                                    padding : 130
                                  }]
                                })

                                if(element6.subCategoryList && element6.subCategoryList.length > 0){
                                  const innerSubCat7 = element6.subCategoryList
                                  innerSubCat7.forEach(element7 => {
                                    categoryArray.push({
                                      options: [{
                                        label : element7.categoryName,
                                        value: element7.categoryId,
                                        padding : 150
                                      }]
                                    })
                                  })
                                }

                              })
                            }

                          })
                        }

                      })
                    }

                  })
                }

              })
            }
          });
        }
      }

      if(props.isEdit){
        if(value.categoryId == props.detailsForEdit.categoryId){
          selectedCatOption = {
            label : value.categoryName,
            value: value.categoryId
          }
          setCategoryName(value.categoryId)
        }
      }
      else{
        if(value.categoryId == props.selectedId){
          selectedCatOption = {
            label : value.categoryName,
            value: value.categoryId
          }
          setCategoryName(value.categoryId)
        }
      }

      if(props.isEdit){
        setSubCategoryName(props.detailsForEdit.subCategoryName)
      }
      
      if(selectedCatOption != null){
        setSelectedCategory(selectedCatOption)
      }

      //console.log('categoryArray::'+JSON.stringify(categoryArray))
      
      /*
      categoryArray.push({
        label : value.categoryName,
        value: value.categoryId
      })
      if(props.isEdit){
        if(value.categoryId == props.detailsForEdit.categoryId){
          selectedCatOption = {
            label : value.categoryName,
            value: value.categoryId
          }
          setCategoryName(value.categoryId)
        }
      }
      else{
        if(value.categoryId == props.selectedId){
          selectedCatOption = {
            label : value.categoryName,
            value: value.categoryId
          }
          setCategoryName(value.categoryId)
        }
      }
      
      if(value.subCategoryList !== undefined){
        value.subCategoryList.forEach(function (item, index) {
          subCategoryArray.push({
            label : item.categoryName,
            value: item.categoryId
          })
        });
      }
      */
    }

    /*

    if(props.isEdit){
      setSubCategoryName(props.detailsForEdit.subCategoryName)
    }
    
    if(selectedCatOption != null){
      setSelectedCategory(selectedCatOption)
    }

    const optionGroup = [
      {
        label: "Category",
        options: categoryArray,
      },
      {
        label: "Sub Category",
        options: subCategoryArray,
      },
    ]
    */
    setCategoryList(categoryArray)

  }, [props.selectedId, props.detailsForEdit])

  /*
  useEffect(() => {
    let categoryArray = [];
    let subCategoryArray = [];
    let selectedCatOption = null;
    console.log('props.categorySubCategoryMap:'+JSON.stringify(props.categorySubCategoryMap))
    for (const [key, value] of Object.entries(props.categorySubCategoryMap)) {
      categoryArray.push({
        label : value.categoryName,
        value: value.categoryId
      })
      if(props.isEdit){
        if(value.categoryId == props.detailsForEdit.categoryId){
          selectedCatOption = {
            label : value.categoryName,
            value: value.categoryId
          }
          setCategoryName(value.categoryId)
        }
      }
      else{
        if(value.categoryId == props.selectedId){
          selectedCatOption = {
            label : value.categoryName,
            value: value.categoryId
          }
          setCategoryName(value.categoryId)
        }
      }
      
      if(value.subCategoryList !== undefined){
        value.subCategoryList.forEach(function (item, index) {
          subCategoryArray.push({
            label : item.categoryName,
            value: item.categoryId
          })
        });
      }
    }

    if(props.isEdit){
      setSubCategoryName(props.detailsForEdit.subCategoryName)
    }
    
    if(selectedCatOption != null){
      setSelectedCategory(selectedCatOption)
    }

    const optionGroup = [
      {
        label: "Category",
        options: categoryArray,
      },
      {
        label: "Sub Category",
        options: subCategoryArray,
      },
    ]
    setCategoryList(optionGroup)

  }, [props.selectedId, props.detailsForEdit])
*/
  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm(){
    setErrorMessage('')
    const modifiedV = { ...validation }
    let formValid = true;
    if(subCategoryName && subCategoryName != ""){
      modifiedV["subCategoryName"] = true
    }
    else{
      modifiedV["subCategoryName"] = false
      formValid = false
    }

    if(categoryName && categoryName != ""){
      modifiedV["categoryName"] = true
    }
    else{
      modifiedV["categoryName"] = false
      formValid = false
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    
    const formValid = validateForm();

    if(formValid){
      setShowLoading(true)

      const response = await onAddItemDirect({
        'inputKey': categoryName,
        'inputValue' : subCategoryName
      }, 'SubCategory')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetCategoriesAndSubCategories(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    
    const formValid = validateForm();

    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
        'id': props.detailsForEdit.subCategoryId,
        'key' : categoryName,
        'value' : subCategoryName
      }, 'SubCategory')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetCategoriesAndSubCategories(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }

      /*
      dispatch(onEditItem({
        'id': props.detailsForEdit.subCategoryId,
        'key' : categoryName,
        'value' : subCategoryName
      }, 'SubCategory'))*/
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                            <Label for="productcategory">
                              Product Category
                            </Label>
                            <Select
                              value={selectedCategory}
                              onChange={(e) => {
                                setSelectedCategory(e)
                                onChangeValidation("categoryName", e.value)
                                setCategoryName(e.value)
                              }}
                              options={categoryList}
                              styles={paddingStyles}
                              classNamePrefix="select2-selection"
                              isLoading={false}
                              id="productcategory"
                            />
                            {(validation["categoryName"] === false) &&
                              <div className="custom-error">
                                Please select a Category
                              </div>
                            }
                          </div>
                          
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="productcode">
                              Sub Category Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="productcode"
                              maxLength="100"
                              value={subCategoryName}
                              onChange={event => {
                                onChangeValidation("subCategoryName", event.target.value.trim())
                                setSubCategoryName(event.target.value)
                              }}
                              invalid={
                                validation["subCategoryName"] !== true &&
                                validation["subCategoryName"] !== null
                              }
                            />
                            {(validation["subCategoryName"] === false) &&
                              <div className="custom-error">
                                Please enter a Sub Category
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {(showLoading) && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                EDIT
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewSubCategory.propTypes = {
  newlyAddedValue: PropTypes.func,
  onGetCategoriesAndSubCategories: PropTypes.func,
  selectedId: PropTypes.any,
  categorySubCategoryMap: PropTypes.any,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewSubCategory
